import * as React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { appStore } from './stores/AppStore';
import { languageStore } from './stores/LanguageStore';
import { showArticleInformationStore } from './stores/ShowArticleInformationStore';
import { getHTMLElement_Root } from './utils/ViewerUtilities';
import { extractUrlParameters } from './utils/fileSharingUrlUtils';
import { getUrlParamValue } from './utils/utils';

import { initInstance } from '@egr/xbox/base-app/i18n';
import { NoWebGL } from '@egr/xbox/egr-gui-dialogs/overlays/NoWebGL';
import { loadScript } from '@egr/xbox/utils/Helper';
import { PUBLIC_URL } from '@egr/xbox/utils/ReactScriptHelper';

import { joinPath } from '@easterngraphics/wcf/modules/utils/string';

export function startApp(): void {
    void (async () => {
        const urlExtraction = extractUrlParameters();

        await Promise.all([
            // eslint-disable-next-line @typescript-eslint/dot-notation
            window['CSG'] == null ? loadScript(joinPath(PUBLIC_URL, 'w-cf-room', 'libs', 'csg-js', 'csg.min.js')) : Promise.resolve(),
            urlExtraction != null ? appStore.fetchUrlInfo() : Promise.resolve(),
            initInstance(undefined, undefined),
        ]);

        const urlLanguage = getUrlParamValue(location.href, 'l');
        const urlShare = getUrlParamValue(location.href, 'i');

        const selectedLanguage = languageStore.getSelectedLanguage(urlLanguage);
        const showInformation = urlShare === '1';

        languageStore.updateLanguage(selectedLanguage);
        showArticleInformationStore.setShowInformation(showInformation);

        const root = createRoot(getHTMLElement_Root()!);
        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>
        );
    })();
}
function WebGLRenderingContextDetected() {
    // https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/By_example/Detect_WebGL
    // Create canvas element. The canvas is not added to the
    // document itself, so it is never displayed in the
    // browser window.
    const canvas: HTMLCanvasElement = document.createElement('canvas');
    // Get WebGLRenderingContext from canvas element.
    const gl: WebGLRenderingContext | RenderingContext | null = canvas.getContext('webgl') ?? canvas.getContext('experimental-webgl');

    return gl instanceof WebGLRenderingContext;
}

window.addEventListener('load', (event) => {
    if (WebGLRenderingContextDetected()) {
        startApp();
    } else {
        showWebGLContextWarning();
    }
});

function showWebGLContextWarning() {
    const root = createRoot(getHTMLElement_Root()!);
    root.render(
        <React.StrictMode>
            <NoWebGL />
        </React.StrictMode>
    );
}
